import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

// Tom Select over a JSON endpoint returning [{ id, name }, ...].
export default class extends Controller {
  static values = {
    url: String,
    queryUrl: { type: Boolean, default: false },
    once: { type: Boolean, default: false },
  };

  connect() {
    this.select = new TomSelect(this.element, {
      valueField: 'id',
      labelField: 'name',
      searchField: ['name'],
      create: false,
      highlight: true,
      maxOptions: 200,
      load: (query, callback) => this.load(query, callback),
      render: {
        option: (item, escape) =>
          `<div class="py-2 d-flex"><div class="mb-1"><span class="h5">${escape(
            item.name,
          )}</span></div></div>`,
      },
    });
  }

  disconnect() {
    if (this.select) this.select.destroy();
  }

  load(query, callback) {
    if (this.select.loading > 1) {
      callback();
      return;
    }

    const url = this.queryUrlValue
      ? `${this.urlValue}${encodeURIComponent(query || '')}`
      : this.urlValue;

    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        callback(json);
        if (this.onceValue) this.select.settings.load = null;
      })
      .catch(() => callback());
  }
}
